module.exports = __webpack_public_path__ + "static/media/bowling-pins.7732f2cb.svg";